import { buildSort, goPromise } from "@delanobgt/admin-core/util/helpers";
import {
  ApiClientFactory,
  IMeta,
  IPagination,
  ISort,
} from "@delanobgt/admin-core/util/types";
import { CancelTokenSource } from "axios";
import _ from "lodash";

import {
  EPackageSetSortField,
  IPackageSet,
  PPackageSetFilter,
} from "../entities";
import IPackageSetRepository from "../repository";

export default class PackageSetRepository
  implements IPackageSetRepository<CancelTokenSource> {
  private apiClientFactory: ApiClientFactory;

  // api routes
  private BANK_ROUTE = "/admin/package-set";

  constructor(apiClientFactory: ApiClientFactory) {
    this.apiClientFactory = apiClientFactory;
  }

  buildFilter = (filter: PPackageSetFilter) => {
    return filter;
  };

  private getSignalToken(signal: CancelTokenSource) {
    return _.get(signal, "token", null);
  }

  private getError(error: any) {
    return _.get(error, "response.data.errors", "Something went wrong.");
  }

  async getPackageSet(
    pagination: IPagination,
    filter: PPackageSetFilter,
    sorts: ISort<EPackageSetSortField>[],
    signal?: CancelTokenSource
  ): Promise<[IPackageSet[], IMeta]> {
    const sort = buildSort(sorts);
    const params = _.pickBy(
      {
        ...pagination,
        ...this.buildFilter(filter),
      },
      Boolean
    );
    const [err, response] = await goPromise(
      this.apiClientFactory({ cancelToken: this.getSignalToken(signal) }).get(
        `${this.BANK_ROUTE}?sort=${sort}`,
        {
          params,
        }
      )
    );
    if (err) {
      throw this.getError(err);
    }
    const { data, meta } = response.data;
    return [data, meta];
  }

  async getPackageSetById(id: number): Promise<IPackageSet> {
    const [err, response] = await goPromise(
      this.apiClientFactory().get(`${this.BANK_ROUTE}/${id}`)
    );
    if (err) {
      throw this.getError(err);
    }
    return response.data;
  }
}
